<ng-select appendTo="body"  [(ngModel)]='model' (change)="select.emit(model)" [compareWith]="compareFn" [placeholder]='placeholder'  style="overflow-x: auto;">
    <ng-option *ngFor="let item of paths" [value]="item.path">
        <span triggers="hover" ngbTooltip="{{ item.path }}" container="body">{{ item.label }}</span>
        <br>
        <small style="color:grey" ><i>{{ item.path }}</i></small>
    </ng-option>
</ng-select>